import {Injectable} from "@angular/core";
import * as CryptoJS from '../../../assets/scripts/crypto-js'
import {UmbrellaValidators} from "../validation/umbrella-validators";
import {EmailValidator} from "../validation/email-validator";

@Injectable({providedIn: "root"})
export class AesEncryptorService {

	private readonly SECRET_KEY: string = "3130303537324137443441333633343231373942313036364430433636374541";
	private readonly IV: string = "00000000000000000000";

	encrypt(message: string, encodeBase64: boolean = false): string {
		const key = CryptoJS.enc.Hex.parse(this.SECRET_KEY);
		const iv = CryptoJS.enc.Hex.parse(this.IV);
		let encrypted = CryptoJS.AES.encrypt(message, key, {iv: iv, padding: CryptoJS.pad.Iso10126, mode: CryptoJS.mode.CBC}).toString();
		return encodeBase64 ? window.btoa(encodeURIComponent(encrypted)) : encrypted;
	}

	decrypt(message: string, isBase64Encoded: boolean = false): string {
		if (EmailValidator.validateEmail(message) == null) { // for old production emails
			return message;
		}

		if (isBase64Encoded) {
			message = decodeURIComponent(window.atob(message))
		}

		const key = CryptoJS.enc.Hex.parse(this.SECRET_KEY);
		const iv = CryptoJS.enc.Hex.parse(this.IV);
		return CryptoJS.AES.decrypt(message, key, {iv: iv, padding: CryptoJS.pad.Iso10126, mode: CryptoJS.mode.CBC	}).toString(CryptoJS.enc.Utf8)
	}
}
